import axios from "axios";
import { notification } from "antd";
import get from "lodash/get";
import { LOGOUT } from "../constants/routes";

const configureAxios = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_AUTH_HOST,
    timeout: 25000,
  });

export const axiosAuthInstance = configureAxios();

axiosAuthInstance.interceptors.request.use((config) => {
  return config;
});

axiosAuthInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (err) => {
    if (!get(err, "response")) {
      notification.error({
        message: "Something Went wrong",
        description: "Please try again or contact technical team",
      });
    } else {
      notification.error({
        message: get(err, "response.data.message"),
      });
      if (get(err, "response.status") === 401) {
        // eslint-disable-next-line no-undef
        window.location.replace(LOGOUT);
      }
    }
    return Promise.reject(get(err, "response.data"));
  },
);
